import * as client from './baseClient';
import axios from 'axios';

export const getDocuments = (documentType) =>
  client.get(`/api/settings/documents/${documentType}`);

  export const deleteAttachment = (branchId, payload) =>
  client.post(`/api/settings/deleteAttachment/delete/${branchId}`, payload);


  export const addAttachments = async (
    currentDirectory,
    branchId,
    attachments
  ) => {
      try {
        const formData = new FormData();
        formData.append(
          currentDirectory,
          attachments,
          attachments.name
        );

       return axios
          .post(
            `/api/settings/uploadAttachemt/blob/${branchId}`,
            formData,
            {
              'Content-Type': 'multipart/form-data'
            }
          )
           .then((resp) => { 
            var tt =  resp.data;
            return tt;
          }) 
          .catch((err) => {
            // Handle Error Here
            console.error(err);
          });
      } catch (ex) {}
  };
  
